import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResultadosRoutingModule } from './resultados-routing.module';
import { CalificacionComponent } from './calificacion/calificacion.component';
import { SharedModule } from '../../shared/shared.module';
import { PlanesComponent } from './planes/planes.component';
import { SeguimientoPlanComponent } from './seguimiento-plan/seguimiento-plan.component';
import { ReportesComponent } from './reportes/reportes.component';


@NgModule({
  declarations: [
    CalificacionComponent,
    PlanesComponent,
    SeguimientoPlanComponent,
    ReportesComponent,
  ],
  imports: [
    CommonModule,
    ResultadosRoutingModule,
    SharedModule,
]
})
export class ResultadosModule { }
